module.exports = __webpack_public_path__ + "img/SecureSSLEncryption.db055827.png";